//  PWA could run on plenty of display modes:
//    - fullscreen
//    - standalone
//    - minimal-ui
//    - browser
//  To choose how our web app is displayed, we set a display mode da-browse/assets/manifest.json.
//  Browsers aren't required to support all display modes, but they are
//  required to support the spec-defined fallback chain
//  "fullscreen" → "standalone" → "minimal-ui" → "browser"
//  This chain can be overridden using `display_override` key in manifest.json.
//  If the browser doesn't support a given mode, they fall back to the next
//  display mode in the chain.
//
//  Therefore, we need to match display-mode against all the modes in the chain.
//  Note that window.matchMedia check will return true for the 'browser'
//  display mode even when it's not an installed PWA app.
//
//  Also, for iOS Safari, we need to use the non-standard Navigator.standalone check

export const isPWA = () => {
  // Should not be called on server
  if (typeof window === 'undefined') {
    return false;
  }

  // for testing on VM, enable following line
  // return true;

  // Not supported browser (should never happen just crappy bots)
  if (typeof window.matchMedia !== 'function') {
    return false;
  }

  return (
    window.matchMedia('(display-mode: standalone), (display-mode: minimal-ui)').matches ||
    (window.navigator as any).standalone === true
  );
};

export default isPWA;
